import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  const isLinkable = (segment: string, index: number, pathnames: string[]) => {
    // Add logic here to determine if a segment should be a link
    // For example, if the next segment is just a number, it might not be linkable
    if (index < pathnames.length - 1 && /^\d+$/.test(pathnames[index + 1])) {
      return false;
    }
    return true;
  };

  // Format display value: capitalize first letter and replace hyphens with spaces
  const formatDisplayValue = (value: string): string => {
    const withSpaces = value.replace(/-/g, ' ').replace(/%20/g, ' ');
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
  };

  // Build breadcrumb items - add Dashboard as first item if not already present
  const breadcrumbItems = pathnames.length > 0 && 
    pathnames[0] !== 'dashboard' && 
    pathnames[0] !== 'home' &&
    location.pathname !== '/home'
    ? ['dashboard', ...pathnames]
    : pathnames;

  return (
    <nav aria-label="Breadcrumb">
      <ol className="list-reset flex" style={{ alignItems: 'center', gap: '0.5rem' }}>
        {breadcrumbItems.map((value, index) => {
          const isLast = index === breadcrumbItems.length - 1;
          const displayValue = formatDisplayValue(value);
          
          // Build the path for navigation
          let to: string;
          if (value === 'dashboard' || value === 'home') {
            to = '/home';
          } else {
            // If dashboard was prepended, map index back to original pathnames
            if (breadcrumbItems[0] === 'dashboard' && index > 0) {
              // Map to original pathnames array
              const pathIndex = index - 1;
              to = `/${pathnames.slice(0, pathIndex + 1).join('/')}`;
            } else {
              // Use breadcrumbItems directly
              to = `/${breadcrumbItems.slice(0, index + 1).join('/')}`;
            }
          }

          return (
            <li key={`${value}-${index}`} style={{ display: 'flex', alignItems: 'center' }}>
              {index > 0 && (
                <span style={{ margin: '0 0.5rem', color: '#9CA3AF' }}>&gt;</span>
              )}
              {isLast ? (
                <span style={{ color: '#364153;' }}>{displayValue}</span>
              ) : (
                <Link
                  to={to}
                  style={{ 
                    color: '#7E57C2', 
                    textDecoration: 'none',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                  onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                >
                  {displayValue}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
